module.exports = "/images/deleteIcon.svg?1384c257cead7f2d8acfdbafe23300a2";